var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApproach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "#002E9E",
    rx: 23
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.016 31.134v1.518a.347.347 0 0 1-.348.348h-13.75a.35.35 0 0 1-.349-.348v-1.518c0-.589.119-1.104.348-1.526.004-.01.01-.017.014-.027.38-.676 1.045-1.132 2.027-1.38a.216.216 0 0 1-.018-.065c-.258-1.546 1.024-2.514 2.263-3.451.77-.578 1.564-1.18 2-1.908.313-.526.424-.94.306-1.142-.08-.133-.276-.192-.432-.213-.307.509-1.25 1.727-3.326 1.915-.344.31-.591.56-.793.766-.46.467-.739.749-1.288.749-.478 0-1.85-.352-2.424-1.23-.313-.48-.348-1.04-.094-1.622.665-1.525 2.082-3.276 2.434-3.698.038-.602.32-3.13 2.239-3.569.212-1.055.511-1.584.96-1.706.345-.097.704.07 1.063.491.71.825 1.236 1.177 1.824 1.212.721.045 5.2 1.535 6.125 4.774.878 3.074.68 6.908-.462 8.917-.004.007-.008.014-.014.018.633.268 1.086.665 1.365 1.197.003.01.01.021.017.032.209.41.313.902.313 1.466Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproach);
export default __webpack_public_path__ + "static/media/approach.fdb7bb3fdc3b2807ada03187d8859278.svg";
export { ForwardRef as ReactComponent };